export default __webpack_public_path__ + "static/media/Ajustes Modelo.7a9a23a2.png";